import * as React from 'react';
import cx from 'classnames';

// Hooks
import { useTranslation } from '@shopee-user/platform';

import styles from './style.scss';

export default function AuthPasswordRules({
  hasError = false,
  className = null,
}: {
  hasError?: boolean;
  className?: string | null;
}) {
  const I18n = useTranslation();
  return (
    <div className={cx(className, hasError ? styles.hasError : null)}>
      <div>
        {I18n.t(
          'msg_auth_password_must_be_long_and_contain_uppercase_and_lowercase'
        )}
      </div>
    </div>
  );
}
